class NotificationPwaTemplate extends NotificationPwa {
    constructor(availableFlag) {

        if (!super(availableFlag)) {
            return false;
        }
    }

    shopPopupSubscription() {
        BX.Sotbit.B2C.showPopup({
            html: '<p class="mb-1 pe-5">' + BX.message('MODAL_CONTENT') + '</p>',
            showCancelButton: false,
            confirmButtonText: BX.message('MODAL_BUTTON_TEXT'),
            width: '413px',
            position: 'bottom-end',
            backdrop: BX.Sotbit.B2C.isMobile(),
            showClass: {
                popup: `pwa-form__popup--show`,
            },
            hideClass: {
                popup: `pwa-form__popup--hide`,
            },
            fixBodyScroll: false,
            customClass: {
                container: 'cookies-form',
                confirmButton: 'btn w-100',
                cancelButton: 'btn btn-secondary',
                closeButton: 'text-secondary-500',
                actions: 'd-sm-flex flex-sm-column',
            },
        }).then(async results => {
            const result = await results[0];

            if (result.isConfirmed) {
                super.handlePushButtonClick();
            } else {
                super.saveNotificationDenied();
            }
        });
    }
}
